module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - ' + (_vm._.isNull(_vm.fep.id) ? 'FEP' : 'FEP nº ' + _vm.fep.id)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("FEP")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Edital',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
    attrs: {
      "name": "frmRegNotice",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [_c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('projeto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "initialDate"
    }
  }, [_vm._v("Propostas: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.projetos,
      "multiple": false,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione uma Proposta",
      "label": "ds_nome",
      "track-by": "id",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "proposta",
      "data-vv-as": "Propostas",
      "options-limit": 1500
    },
    on: {
      "select": function($event) {
        return _vm.moveObjeto($event)
      },
      "remove": function($event) {
        return _vm.removeObjeto()
      }
    },
    model: {
      value: (_vm.fep.proposta),
      callback: function($$v) {
        _vm.$set(_vm.fep, "proposta", $$v)
      },
      expression: "fep.proposta"
    }
  })], 1)]), _vm._v(" "), (_vm.errors.first('projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('numeroEdital')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "numeroFep"
    }
  }, [_vm._v("Número da FEP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fep.id),
      expression: "fep.id"
    }],
    staticClass: "form-control ng-pristine ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required ng-touched",
    attrs: {
      "name": "numeroFep",
      "disabled": true,
      "type": "text",
      "minlength": "1",
      "ng-maxlength": "255",
      "required": ""
    },
    domProps: {
      "value": (_vm.fep.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fep, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": _vm.fep.id > 0 || _vm.selecionado === false
    },
    on: {
      "click": _vm.grava
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Gerar Número")])]), _vm._v(" "), (_vm.errors.first('numeroEdital')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('numeroFep')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de FEP")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c357818!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/fep/EditaFep.vue
// module id = 1875
// module chunks = 1